const caseTimeLog = {
    add () {
      return `/homeowner/casetimelog/add`;
    },
  
    update () {
      return `/homeowner/casetimelog/update`;
    },
  
    delete (id) {
      return `/homeowner/casetimelog/${id}`;
    },

    approve () {
      return `/homeowner/casetimelog/user/approve`;
    },
    
    getListByCase (controlidnumber) {
      return `/homeowner/casetimelog/case/${controlidnumber}`;
    },
    
    getListByUserPayPeriod (internetUserId, payPeriodId) {
      return `/homeowner/casetimelog/user/${internetUserId}/payperiod/${payPeriodId}`;
    },
    
    getListUsersByManagerPayPeriod (managerUserId, payPeriodId) {
      return `/homeowner/casetimelog/manager/${managerUserId}/users/payperiod/${payPeriodId}`;
    },

    getListUsersByManagerPending (managerUserId, fromDate, toDate) {
      return `/homeowner/casetimelog/manager/${managerUserId}/users/pending/daterange/${fromDate}/${toDate}`;
    },

    getPayPeriodList (numberOfPayPeriods = null) {
      let endpoint = `/homeowner/casetimelog/payperiodlist`;
      if (numberOfPayPeriods !== null) {
        endpoint += `?number=${numberOfPayPeriods}`;
      }
      return endpoint;
    },

    getApprovedPayPeriodList (internetUserId, payPeriodId) {
      return `/homeowner/casetimelog/user/${internetUserId}/payperiod/${payPeriodId}/approved/`;
    },

    submitFeedback () {
      return '/homeowner/casetimelog/feedback';
    },

    getFeedback (controlNumber) {
      return `/homeowner/casetimelog/feedback/${controlNumber}`;
    },    

    getFeedbackCategories (workTypeId) {
      return `/homeowner/casetimelog/feedback-categories/${workTypeId}`;
    },
};

export default caseTimeLog;